import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';

export const Container = styled.div`
  padding: 0.375rem 1rem 0.5rem;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.375rem;
  padding-top: 0.375rem;
`;

export const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 0.375rem;
  color: var(--colors-brand-primary);

  > h3 {
    font-size: 0.875rem;
    font-weight: 700;
    color: var(--colors-foreground-100);
  }
`;

export const ViewAllLink = styled(Link)`
  ${({ theme }) => css`
    font-size: 0.6875rem;
    color: ${theme.colors.brand.primary.default};
    font-weight: 600;
  `}
`;

export const FeedItem = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    gap: 0.625rem;
    padding: 0.3rem 0.35rem;
    border-radius: 0.5rem;
    transition: all 0.2s ease;
    cursor: pointer;

    &:not(:last-child) {
      border-bottom: 1px solid ${theme.colors.background[60]};
    }

    &:hover {
      background: rgba(0, 0, 0, 0.02);
    }
  `}
`;

export const FeedAvatar = styled.div`
  width: 2.1rem;
  height: 2.1rem;
  border-radius: 0.5rem;
  flex-shrink: 0;
  position: relative;
  overflow: visible;

  > img {
    width: 100%;
    height: 100%;
    border-radius: 0.5rem;
    object-fit: cover;
  }
`;

export const TypeIcon = styled.div`
  ${({ theme }) => css`
    position: absolute;
    bottom: -0.125rem;
    right: -0.125rem;
    width: 0.9375rem;
    height: 0.9375rem;
    border-radius: 50%;
    background: ${theme.colors.background[100]};
    border: 1.5px solid ${theme.colors.background[60]};
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${theme.colors.foreground[40]};
  `}
`;

export const FeedContent = styled.div`
  flex: 1;
  min-width: 0;

  > p {
    font-size: 0.75rem;
    color: var(--colors-foreground-80);
    line-height: 1.3;

    > strong {
      font-weight: 600;
    }

    > span {
      color: var(--colors-foreground-40);
    }
  }
`;

export const EmptyState = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 0.875rem 0.75rem 0.5rem;
    gap: 0.375rem;

    > svg {
      color: ${theme.colors.brand.primary.default};
      opacity: 0.85;
      margin-bottom: 0.125rem;
    }

    > strong {
      font-size: 0.8125rem;
      font-weight: 600;
      color: ${theme.colors.foreground[100]};
    }

    > span {
      font-size: 0.6875rem;
      color: ${theme.colors.foreground[60]};
      line-height: 1.4;
      max-width: 14rem;
    }
  `}
`;

export const FeedTime = styled.span`
  font-size: 0.625rem;
  color: var(--colors-foreground-40);
  flex-shrink: 0;
  font-weight: 500;
`;
